import script from "./TarifBeschreibung.vue?vue&type=script&setup=true&lang=js"
export * from "./TarifBeschreibung.vue?vue&type=script&setup=true&lang=js"

import "./TarifBeschreibung.vue?vue&type=style&index=0&id=56622c1c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56622c1c"]])

export default __exports__